import React from 'react';

const SettlementIcon = () => {
  return (
<svg version="1.1" 
id="Layer_1" 
xmlns="http://www.w3.org/2000/svg" 
xmlnsXlink="http://www.w3.org/1999/xlink"
 x="0px" 
 y="0px"
viewBox="0 0 20 16" 
style={{'enableBackground':'new 0 0 20 16', width:'20px'}} 
xmlSpace="preserve">
<path d="M0,16h20v-4H0V16z M2,13h2v2H2V13z M0,0v4h20V0H0z M4,3H2V1h2V3z M0,10h20V6H0V10z M2,7h2v2H2V7z"/>
</svg>

  );
};

export default SettlementIcon;
